"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ = _interopRequireDefault(require("@carbon/icons-react/lib/play--outline--filled/32.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.play-button svg {\n  width: 56px;\n  height: 56px;\n  cursor: pointer;\n  color: #fff; }\n\n.play-button svg.black {\n  color: #000000; }\n";
  const fileName = "PlayButton_PlayButton";
  const element = document.querySelector("style[data-sass-component='PlayButton_PlayButton']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const PlayButton = _ref => {
  let {
    onClick,
    showBlackIcon
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "play-button",
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_.default, {
    className: showBlackIcon ? 'black' : ''
  }));
};
PlayButton.propTypes = {
  showBlackIcon: _propTypes.default.bool,
  onClick: _propTypes.default.func
};
PlayButton.defaultProps = {
  showBlackIcon: false,
  onClick: () => null
};
var _default = exports.default = PlayButton;